import { atom } from 'jotai';
export const $ABTest = atom({
    versions: '',
    parameters: {},
});
$ABTest.debugLabel = '$ABTest';
//# sourceMappingURL=ab-test.js.map